module.exports = __webpack_public_path__ + "img/Sleet.e1202bb6.png";